export default __webpack_public_path__ + "static/media/slider1.19a2872d.png";